export default __webpack_public_path__ + "static/media/img3.cf673fb5.png";